<span
  class="status-chip inline-flex items-center gap-2 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium"
  [class]="colorClass()"
  [attr.data-testid]="testId()"
  [attr.data-status]="status()"
>
  <span class="status-dot h-2 w-2 rounded-full"></span>
  {{ labelKey() | transloco }}
</span>
